export default "__VITE_ASSET__ClrBTHLy__"